import { Allocation, AllocationCard, AllocationRule, BookingStatus, Entity } from '@jms/model';

export interface NewAllocationInfo {
    resources: Entity[];
    startDate: Date;
    endDate: Date;
    note: string;
    additionalDays?: number;
    bookingStatus?: BookingStatus;
}

export enum AllocationEditType {
    This = 'This',
    ThisAndFuture = 'ThisAndFuture',
    All = 'All',
}

export const AllocationEditTypeOptions = [
    [AllocationEditType.This, 'This instance'],
    [AllocationEditType.ThisAndFuture, 'This and all future instances'],
    [AllocationEditType.All, 'All instances in the series'],
];

export type AllocationEditModel = {
    allocation: AllocationCard;
    type?: AllocationEditType;
}

export type AllocationGroupBy = {
    id: number;
    rule: AllocationRule;
}

export interface AllocationEditFormInput extends Allocation {
    editCategory?: 'added' | 'modified' | 'deleted';
    hide?: boolean;
    canRecurrence?: boolean;
}